module.exports = __webpack_public_path__ + "static/media/7.04d6531f.jpg";